<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  modelValue: { type: String, required: true },
  participants: { type: Array, default: () => [] },
});

const emit = defineEmits(['update:modelValue']);
const { t } = useI18n();
const participantCount = role =>
  props.participants.filter(
    participant =>
      (participant.role || participant.party_role) === role &&
      participant.relation_type !== 'representante'
  ).length;
const options = computed(() => [
  {
    value: 'vendedor',
    label: `${t('SALES.DELIVERY.EMAILS.VENDEDORES')} (${participantCount('vendedor')})`,
  },
  {
    value: 'comprador',
    label: `${t('SALES.DELIVERY.EMAILS.COMPRADORES')} (${participantCount('comprador')})`,
  },
  { value: 'copies', label: t('SALES.DELIVERY.EMAILS.COPIES') },
]);
</script>

<template>
  <div class="flex flex-wrap gap-2 border-b border-lais-border pb-3">
    <button
      v-for="option in options"
      :key="option.value"
      type="button"
      class="rounded-lais-sm px-3 py-2 text-sm font-semibold"
      :class="
        modelValue === option.value
          ? 'bg-lais-primary text-white'
          : 'bg-lais-bg-soft text-lais-text'
      "
      @click="emit('update:modelValue', option.value)"
    >
      {{ option.label }}
    </button>
  </div>
</template>
